__turbopack_context__.v({
  "inputContainer": "Input-module__kTHQ0G__inputContainer",
  "textarea": "Input-module__kTHQ0G__textarea",
});
